<template>
    <div class="header">
        TODO: ResultHeader
        <!--Asta:ResultHeader TODO, sortering mm-->
    </div>
</template>
<script lang="ts" setup>
</script>